export enum SYSTEM_ACTION_ROLES_ENUM {
  // EDIT

  CUSTOMER_REGISTRATION_EDIT_BUTTON_SHOW = "CUSTOMER_REGISTRATION_EDIT_BUTTON_SHOW",
  CUSTOMER_REGISTRATION_EDIT_BUTTON_ENABLE = "CUSTOMER_REGISTRATION_EDIT_BUTTON_ENABLE",
  CUSTOMER_ACESS_EDIT_BUTTON_SHOW = "CUSTOMER_ACESS_EDIT_BUTTON_SHOW",
  CUSTOMER_ACESS_EDIT_BUTTON_ENABLED = "CUSTOMER_ACESS_EDIT_BUTTON_ENABLE",
  SERVICE_ORDER_EDIT_BUTTON_SHOW = "SERVICE_ORDER_EDIT_BUTTON_SHOW",
  SERVICE_ORDER_EDIT_BUTTON_ENABLED = "SERVICE_ORDER_EDIT_BUTTON_ENABLED",
  SOLUTION_EDIT_BUTTON_SHOW = "SOLUTION_EDIT_BUTTON_SHOW",
  SOLUTION_EDIT_BUTTON_ENABLED = "SOLUTION_EDIT_BUTTON_ENABLED",
  MARKETING_EDIT_BUTTON_SHOW = "MARKETING_EDIT_BUTTON_SHOW",
  MARKETING_EDIT_BUTTON_ENABLED = "MARKETING_EDIT_BUTTON_ENABLED",
  TRAINING_EDIT_BUTTON_SHOW = "TRAINING_EDIT_BUTTON_SHOW",
  TRAINING_EDIT_BUTTON_ENABLED = "TRAINING_EDIT_BUTTON_ENABLED",
  EVENT_EDIT_BUTTON_SHOW = "EVENT_EDIT_BUTTON_SHOW",
  EVENT_EDIT_BUTTON_ENABLED = "EVENT_EDIT_BUTTON_ENABLED",
  FAQ_EDIT_BUTTON_SHOW = "FAQ_EDIT_BUTTON_SHOW",
  FAQ_EDIT_BUTTON_ENABLED = "FAQ_EDIT_BUTTON_ENABLED",
  PLAN_EDIT_BUTTON_SHOW = "PLAN_EDIT_BUTTON_SHOW",
  PLAN_EDIT_BUTTON_ENABLED = "PLAN_EDIT_BUTTON_ENABLED",
  SYSTEM_EDIT_BUTTON_SHOW = "SYSTEM_EDIT_BUTTON_SHOW",
  SYSTEM_EDIT_BUTTON_ENABLED = "SYSTEM_EDIT_BUTTON_ENABLED",
  SYSTEM_EXTERNAL_EDIT_BUTTON_SHOW = "SYSTEM_EXTERNAL_EDIT_BUTTON_SHOW",
  SYSTEM_EXTERNAL_EDIT_BUTTON_ENABLED = "SYSTEM_EXTERNAL_EDIT_BUTTON_ENABLED",
  SYSTEM_MODULE_EDIT_BUTTON_SHOW = "SYSTEM_MODULE_EDIT_BUTTON_SHOW",
  SYSTEM_MODULE_EDIT_BUTTON_ENABLED = "SYSTEM_MODULE_EDIT_BUTTON_ENABLED",
  USERS_EDIT_BUTTON_SHOW = "USERS_EDIT_BUTTON_SHOW",
  USERS_EDIT_BUTTON_ENABLED = "USERS_EDIT_BUTTON_ENABLED",
  PARTNERS_EDIT_BUTTON_SHOW = "PARTNERS_EDIT_BUTTON_SHOW",
  PARTNERS_EDIT_BUTTON_ENABLED = "PARTNERS_EDIT_BUTTON_ENABLED",
  PROVIDERS_EDIT_BUTTON_SHOW = "PROVIDERS_EDIT_BUTTON_SHOW",
  PROVIDERS_EDIT_BUTTON_ENABLED = "PROVIDERS_EDIT_BUTTON_ENABLED",

  CUSTOMER_DELETE_BUTTON_SHOW = "CUSTOMER_DELETE_BUTTON_SHOW",
  CUSTOMER_DELETE_BUTTON_ENABLED = "CUSTOMER_DELETE_BUTTON_ENABLED",
  CUSTOMER_ACESS_DELETE_BUTTON_SHOW = "CUSTOMER_ACESS_DELETE_BUTTON_SHOW",
  CUSTOMER_ACESS_DELETE_BUTTON_ENABLED = "CUSTOMER_ACESS_DELETE_BUTTON_ENABLED",
  SERVICE_ORDER_DELETE_BUTTON_SHOW = "SERVICE_ORDER_DELETE_BUTTON_SHOW",
  SERVICE_ORDER_DELETE_BUTTON_ENABLED = "SERVICE_ORDER_DELETE_BUTTON_ENABLED",
  SOLUTION_DELETE_BUTTON_SHOW = "SOLUTION_DELETE_BUTTON_SHOW",
  SOLUTION_DELETE_BUTTON_ENABLED = "SOLUTION_DELETE_BUTTON_ENABLED",
  MARKETING_DELETE_BUTTON_SHOW = "MARKETING_DELETE_BUTTON_SHOW",
  MARKETING_DELETE_BUTTON_ENABLED = "MARKETING_DELETE_BUTTON_ENABLED",
  TRAINING_DELETE_BUTTON_SHOW = "TRAINING_DELETE_BUTTON_SHOW",
  TRAINING_DELETE_BUTTON_ENABLED = "TRAINING_DELETE_BUTTON_ENABLED",
  EVENT_DELETE_BUTTON_SHOW = "EVENT_DELETE_BUTTON_SHOW",
  EVENT_DELETE_BUTTON_ENABLED = "EVENT_DELETE_BUTTON_ENABLED",
  FAQ_DELETE_BUTTON_SHOW = "FAQ_DELETE_BUTTON_SHOW",
  FAQ_DELETE_BUTTON_ENABLED = "FAQ_DELETE_BUTTON_ENABLED",
  PLAN_DELETE_BUTTON_SHOW = "PLAN_DELETE_BUTTON_SHOW",
  PLAN_DELETE_BUTTON_ENABLED = "PLAN_DELETE_BUTTON_ENABLED",
  SYSTEM_DELETE_BUTTON_SHOW = "SYSTEM_DELETE_BUTTON_SHOW",
  SYSTEM_DELETE_BUTTON_ENABLED = "SYSTEM_DELETE_BUTTON_ENABLED",
  SYSTEM_EXTERNAL_DELETE_BUTTON_SHOW = "SYSTEM_EXTERNAL_DELETE_BUTTON_SHOW",
  SYSTEM_EXTERNAL_DELETE_BUTTON_ENABLED = "SYSTEM_EXTERNAL_DELETE_BUTTON_ENABLED",
  SYSTEM_MODULE_DELETE_BUTTON_SHOW = "SYSTEM_MODULE_DELETE_BUTTON_SHOW",
  SYSTEM_MODULE_DELETE_BUTTON_ENABLED = "SYSTEM_MODULE_DELETE_BUTTON_ENABLED",
  USERS_DELETE_BUTTON_SHOW = "USERS_DELETE_BUTTON_SHOW",
  USERS_DELETE_BUTTON_ENABLED = "USERS_DELETE_BUTTON_ENABLED",
  PARTNERS_DELETE_BUTTON_SHOW = "PARTNERS_DELETE_BUTTON_SHOW",
  PARTNERS_DELETE_BUTTON_ENABLED = "PARTNERS_DELETE_BUTTON_ENABLED",
  PROVIDERS_DELETE_BUTTON_SHOW = "PROVIDERS_DELETE_BUTTON_SHOW",
  PROVIDERS_DELETE_BUTTON_ENABLED = "PROVIDERS_DELETE_BUTTON_ENABLED",

  MERCHANT_DELETE_BUTTON_SHOW = "MERCHANT_DELETE_BUTTON_SHOW",
  MERCHANT_DELETE_BUTTON_ENABLED = "MERCHANT_DELETE_BUTTON_ENABLED",
  MERCHANT_EDIT_BUTTON_SHOW = "MERCHANT_EDIT_BUTTON_SHOW",
  MERCHANT_EDIT_BUTTON_ENABLED = "MERCHANT_EDIT_BUTTON_ENABLED",

  CONTRACTS_DELETE_BUTTON_SHOW = "CONTRACTS_DELETE_BUTTON_SHOW",
  CONTRACTS_DELETE_BUTTON_ENABLED = "CONTRACTS_DELETE_BUTTON_ENABLED",
  CONTRACTS_EDIT_BUTTON_SHOW = "CONTRACTS_EDIT_BUTTON_SHOW",
  CONTRACTS_EDIT_BUTTON_ENABLED = "CONTRACTS_EDIT_BUTTON_ENABLED",

  MENU_CONTRACTS_SHOW = "MENU_CONTRACTS_SHOW",
  MENU_CONTRACTS_ENABLE = "MENU_CONTRACTS_ENABLE",
  MENU_CONTRACTS_CARDS_SHOW = "MENU_CONTRACTS_CARDS_SHOW",
  MENU_CONTRACTS_CARDS_ENABLE = "MENU_CONTRACTS_CARDS_ENABLE",

  CUSTOMER_GENERATE_ACCESS_BUTTON_SHOW = "CUSTOMER_GENERATE_ACCESS_BUTTON_SHOW",
  CUSTOMER_GENERATE_ACCESS_BUTTON_ENABLED = "CUSTOMER_GENERATE_ACCESS_BUTTON_ENABLED",
  CUSTOMER_ACCESSES_BUTTON_SHOW = "CUSTOMER_ACCESSES_BUTTON_SHOW",
  CUSTOMER_ACCESSES_BUTTON_ENABLED = "CUSTOMER_ACCESSES_BUTTON_ENABLED",

  PLAN_LOCK_ACTION_SHOW = "PLAN_LOCK_ACTION_SHOW",
  PLAN_LOCK_ACTION_ENABLED = "PLAN_LOCK_ACTION_ENABLED",

  // Grupo de Permissoes: roles PROPRIAS (antes reutilizava SYSTEM_EDIT/DELETE_BUTTON
  // da tela Solucoes). Legado tratado em legacy-role-fallback.ts.
  PERMISSION_GROUP_EDIT_BUTTON_SHOW = "PERMISSION_GROUP_EDIT_BUTTON_SHOW",
  PERMISSION_GROUP_EDIT_BUTTON_ENABLED = "PERMISSION_GROUP_EDIT_BUTTON_ENABLED",
  PERMISSION_GROUP_DELETE_BUTTON_SHOW = "PERMISSION_GROUP_DELETE_BUTTON_SHOW",
  PERMISSION_GROUP_DELETE_BUTTON_ENABLED = "PERMISSION_GROUP_DELETE_BUTTON_ENABLED",

  // Configuracoes > Integracoes > Barid: uma role por botao. Na transicao valem
  // por MENU_SETTINGS (legacy-role-fallback.ts, familia barid-settings-split).
  BARID_INSTALLER_DOWNLOAD_BUTTON_SHOW = "BARID_INSTALLER_DOWNLOAD_BUTTON_SHOW",
  BARID_INSTALLER_DOWNLOAD_BUTTON_ENABLED = "BARID_INSTALLER_DOWNLOAD_BUTTON_ENABLED",
  BARID_DEVICE_PAIR_BUTTON_SHOW = "BARID_DEVICE_PAIR_BUTTON_SHOW",
  BARID_DEVICE_PAIR_BUTTON_ENABLED = "BARID_DEVICE_PAIR_BUTTON_ENABLED",
  BARID_DEVICE_NEW_CODE_BUTTON_SHOW = "BARID_DEVICE_NEW_CODE_BUTTON_SHOW",
  BARID_DEVICE_NEW_CODE_BUTTON_ENABLED = "BARID_DEVICE_NEW_CODE_BUTTON_ENABLED",
  BARID_DEVICE_RENAME_BUTTON_SHOW = "BARID_DEVICE_RENAME_BUTTON_SHOW",
  BARID_DEVICE_RENAME_BUTTON_ENABLED = "BARID_DEVICE_RENAME_BUTTON_ENABLED",
  BARID_DEVICE_DELETE_BUTTON_SHOW = "BARID_DEVICE_DELETE_BUTTON_SHOW",
  BARID_DEVICE_DELETE_BUTTON_ENABLED = "BARID_DEVICE_DELETE_BUTTON_ENABLED",
  BARID_TEF_SAVE_BUTTON_SHOW = "BARID_TEF_SAVE_BUTTON_SHOW",
  BARID_TEF_SAVE_BUTTON_ENABLED = "BARID_TEF_SAVE_BUTTON_ENABLED",
  BARID_PRINTER_SYNC_BUTTON_SHOW = "BARID_PRINTER_SYNC_BUTTON_SHOW",
  BARID_PRINTER_SYNC_BUTTON_ENABLED = "BARID_PRINTER_SYNC_BUTTON_ENABLED",
  BARID_PRINTER_TEST_BUTTON_SHOW = "BARID_PRINTER_TEST_BUTTON_SHOW",
  BARID_PRINTER_TEST_BUTTON_ENABLED = "BARID_PRINTER_TEST_BUTTON_ENABLED",
  BARID_PRINTER_SHARE_BUTTON_SHOW = "BARID_PRINTER_SHARE_BUTTON_SHOW",
  BARID_PRINTER_SHARE_BUTTON_ENABLED = "BARID_PRINTER_SHARE_BUTTON_ENABLED",
  BARID_JOB_RESEND_BUTTON_SHOW = "BARID_JOB_RESEND_BUTTON_SHOW",
  BARID_JOB_RESEND_BUTTON_ENABLED = "BARID_JOB_RESEND_BUTTON_ENABLED",
  BARID_DEVICE_PRINT_QUEUE_BUTTON_SHOW = "BARID_DEVICE_PRINT_QUEUE_BUTTON_SHOW",
  BARID_DEVICE_PRINT_QUEUE_BUTTON_ENABLED = "BARID_DEVICE_PRINT_QUEUE_BUTTON_ENABLED",
  BARID_JOB_REDIRECT_BUTTON_SHOW = "BARID_JOB_REDIRECT_BUTTON_SHOW",
  BARID_JOB_REDIRECT_BUTTON_ENABLED = "BARID_JOB_REDIRECT_BUTTON_ENABLED",
  // F3.7 fatia 3: familia propria barid-local-panel-split (legacy-role-fallback.ts).
  BARID_LOCAL_PANEL_BUTTON_SHOW = "BARID_LOCAL_PANEL_BUTTON_SHOW",
  BARID_LOCAL_PANEL_BUTTON_ENABLED = "BARID_LOCAL_PANEL_BUTTON_ENABLED",
  // F3.7 fatia 4: Central de Impressoes (Configuracoes > Central de Impressoes), familia propria
  // print-center-split (legacy-role-fallback.ts).
  PRINT_CENTER_JOB_RESEND_BUTTON_SHOW = "PRINT_CENTER_JOB_RESEND_BUTTON_SHOW",
  PRINT_CENTER_JOB_RESEND_BUTTON_ENABLED = "PRINT_CENTER_JOB_RESEND_BUTTON_ENABLED",
  PRINT_CENTER_JOB_REDIRECT_BUTTON_SHOW = "PRINT_CENTER_JOB_REDIRECT_BUTTON_SHOW",
  PRINT_CENTER_JOB_REDIRECT_BUTTON_ENABLED = "PRINT_CENTER_JOB_REDIRECT_BUTTON_ENABLED",
  // F3.7 fatia 5: troca de computador do terminal (assistente + "Terminais sem computador"), familia propria
  // barid-computer-swap-split (legacy-role-fallback.ts).
  BARID_TERMINAL_REPLACE_COMPUTER_BUTTON_SHOW = "BARID_TERMINAL_REPLACE_COMPUTER_BUTTON_SHOW",
  BARID_TERMINAL_REPLACE_COMPUTER_BUTTON_ENABLED = "BARID_TERMINAL_REPLACE_COMPUTER_BUTTON_ENABLED",
  BARID_REPLACE_COMPUTER_CANDIDATES_BUTTON_SHOW = "BARID_REPLACE_COMPUTER_CANDIDATES_BUTTON_SHOW",
  BARID_REPLACE_COMPUTER_CANDIDATES_BUTTON_ENABLED = "BARID_REPLACE_COMPUTER_CANDIDATES_BUTTON_ENABLED",
  // Padrao ABCX na tela do Barid: testar a conexao do agente e backup/restauracao da configuracao do terminal,
  // familia propria barid-config-backup-split (legacy-role-fallback.ts).
  BARID_AGENT_TEST_BUTTON_SHOW = "BARID_AGENT_TEST_BUTTON_SHOW",
  BARID_AGENT_TEST_BUTTON_ENABLED = "BARID_AGENT_TEST_BUTTON_ENABLED",
  BARID_CONFIG_BACKUP_BUTTON_SHOW = "BARID_CONFIG_BACKUP_BUTTON_SHOW",
  BARID_CONFIG_BACKUP_BUTTON_ENABLED = "BARID_CONFIG_BACKUP_BUTTON_ENABLED",
  BARID_CONFIG_RESTORE_BUTTON_SHOW = "BARID_CONFIG_RESTORE_BUTTON_SHOW",
  BARID_CONFIG_RESTORE_BUTTON_ENABLED = "BARID_CONFIG_RESTORE_BUTTON_ENABLED",
  // Telas Impressoras/Dispositivos do Barid: areas de impressao e apelido da impressora, familia barid-printers-devices-split.
  BARID_PRINT_AREAS_SAVE_BUTTON_SHOW = "BARID_PRINT_AREAS_SAVE_BUTTON_SHOW",
  BARID_PRINT_AREAS_SAVE_BUTTON_ENABLED = "BARID_PRINT_AREAS_SAVE_BUTTON_ENABLED",
  BARID_PRINTER_RENAME_BUTTON_SHOW = "BARID_PRINTER_RENAME_BUTTON_SHOW",
  BARID_PRINTER_RENAME_BUTTON_ENABLED = "BARID_PRINTER_RENAME_BUTTON_ENABLED",
  // Indicador de conectividade do Barid na barra superior (familia barid-printers-devices-split).
  BARID_CONNECTIVITY_INDICATOR_SHOW = "BARID_CONNECTIVITY_INDICATOR_SHOW",
  BARID_CONNECTIVITY_INDICATOR_ENABLED = "BARID_CONNECTIVITY_INDICATOR_ENABLED",
  // NFS-e (nota fiscal de serviço, fatia F5) — catálogo tipo 6 do Nexus (2195100000002)
  MENU_FISCAL_SUBMENU_SERVICE_INVOICES_SHOW = "MENU_FISCAL_SUBMENU_SERVICE_INVOICES_SHOW",
  MENU_FISCAL_SUBMENU_SERVICE_INVOICES_ENABLE = "MENU_FISCAL_SUBMENU_SERVICE_INVOICES_ENABLE",
  SERVICE_INVOICES_EMIT_BUTTON_SHOW = "SERVICE_INVOICES_EMIT_BUTTON_SHOW",
  SERVICE_INVOICES_EMIT_BUTTON_ENABLED = "SERVICE_INVOICES_EMIT_BUTTON_ENABLED",
  SERVICE_INVOICES_CANCEL_BUTTON_SHOW = "SERVICE_INVOICES_CANCEL_BUTTON_SHOW",
  SERVICE_INVOICES_CANCEL_BUTTON_ENABLED = "SERVICE_INVOICES_CANCEL_BUTTON_ENABLED",
  SERVICE_INVOICES_CONSULT_BUTTON_SHOW = "SERVICE_INVOICES_CONSULT_BUTTON_SHOW",
  SERVICE_INVOICES_CONSULT_BUTTON_ENABLED = "SERVICE_INVOICES_CONSULT_BUTTON_ENABLED",
  SERVICE_INVOICES_DOWNLOAD_BUTTON_SHOW = "SERVICE_INVOICES_DOWNLOAD_BUTTON_SHOW",
  SERVICE_INVOICES_DOWNLOAD_BUTTON_ENABLED = "SERVICE_INVOICES_DOWNLOAD_BUTTON_ENABLED",
  SERVICE_INVOICE_SETTINGS_SHOW = "SERVICE_INVOICE_SETTINGS_SHOW",
  SERVICE_INVOICE_SETTINGS_ENABLE = "SERVICE_INVOICE_SETTINGS_ENABLE",
  SERVICE_ORDER_EMIT_NFSE_BUTTON_SHOW = "SERVICE_ORDER_EMIT_NFSE_BUTTON_SHOW",
  SERVICE_ORDER_EMIT_NFSE_BUTTON_ENABLED = "SERVICE_ORDER_EMIT_NFSE_BUTTON_ENABLED",

  MENU_BASE_REGISTRATION_SUBMENU_PRODUCTS_SHOW = "MENU_BASE_REGISTRATION_SUBMENU_PRODUCTS_SHOW",
  MENU_BASE_REGISTRATION_SUBMENU_PRODUCTS_ENABLE = "MENU_BASE_REGISTRATION_SUBMENU_PRODUCTS_ENABLE",
}